export const tyrePositionTypes = {
    front: 1,
    back: 2,
    all : 3
}